import { memo as Memo } from 'react';

//* HOC's
import withLanguageContext from '@/context/consumerHOC/LanguageConsumer';

//* Components
import LazySection from '../LazySection';
import Awards from '@components/global/Awards';
import Button from '@components/global/Button';
import HTMLContainer from '@components/global/HTMLContainer';
import PageTopSection from '@components/global/PageTopSection';
import CursorParticles from '@components/global/CursorParticles';
import AwardsContSkeleton from '@/components/skeleton/AwardsContSkeleton';

//* Styles
import AwardsContStyle from './style';

const AwardsCont = Memo(({ data, anime, type, count, parentClassName, className, link, translate }) => {
	return (
		<AwardsContStyle className={`awardsCont ${parentClassName || ''} ${type === 1 ? 'norm' : 'black'}`}>
			<HTMLContainer>
				<div className={`${className || ''}`}>
					<PageTopSection
						className='aw-section'
						titleTag={'h2'}
						{...data}
					/>

					<LazySection
						delay={500}
						fallback={<AwardsContSkeleton type={type} />}>
						<Awards
							active
							type={type}
							count={count}
							anime={anime}
							className='aw-blocks'
						/>
					</LazySection>

					<Button
						link={link}
						customClass='load-more'
						type={type === 1 ? 1 : ''}
						text={translate('weHaveMoreHere')}
						ariaLabel={translate('weHaveMoreHere')}
					/>
				</div>
			</HTMLContainer>
			<CursorParticles />
		</AwardsContStyle>
	);
});

export default withLanguageContext(AwardsCont, ['translate']);
